module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(!_vm.hasSlot) ? _c('a', {
    attrs: {
      "href": _vm.to
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.separator) ? _c('span', {
    staticClass: "breadcrumb-separator"
  }, [_vm._v(_vm._s(_vm.separator))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ee6bfa4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb/BreadcrumbItem.vue
// module id = 332
// module chunks = 0